export enum BroadcastValidationError {
  ConsumptionUsedCar = 'ConsumptionUsedCar',
  ConsumptionNewCar = 'ConsumptionNewCar_v2',
  ConsumptionNewCarNotElectric = 'ConsumptionNewCarNotElectric',
  ConsumptionNewCarElectricCombinedConsumption = 'ConsumptionNewCarElectricCombinedConsumption',
  ConsumptionNewCarElectricElectricConsumption = 'ConsumptionNewCarElectricElectricConsumption',
  ConsumptionNewCarNotElectricElectricConsumption = 'ConsumptionNewCarNotElectricElectricConsumption',
  CO2EmissionInformationNewCar = 'CO2EmissionInformationNewCar',
}
